import React, { PureComponent } from 'react';
import { createRental } from "../../../../api/apiRequests";
import MySubmit from "../../../shared/form/MySubmit";
import MyInput from "../../../shared/form/MyInput";
import Select from 'react-select';
import law from "./../../../../media/icons/law.svg"

class ModalVespa extends PureComponent {

  state = {
    licensePlate: "",
    model: null
  };
  errors = [];

  captureErrors = (where, isCorrect) => {
    const indice = this.errors.indexOf(where);
    const existsIndice = indice >= 0;
    isCorrect ? (existsIndice && this.errors.splice(indice, 1)) : (!existsIndice && this.errors.push(where));
  };

  changeInfo = (event) => this.setState({
    [event.target.name]: (event.target.value)
  });

  changeModel = (value) => {
    this.setState({ model: value })
  };

  submit = (event) => {
    event.preventDefault();
    if (this.errors.length < 1 && this.state.model !== null) {
      const { licensePlate, model } = this.state;
      const { updateRentals } = this.props;
      createRental(licensePlate, model.value)
      .then(() => {
        updateRentals();
        alert("Vespa creada")
      })
      .catch(() => {
        alert("La vespa no se ha podido crear, lo sentimos")
      })
    } else {
      alert("Por favor, complete los campos requeridos")
    }
  };

  render() {
    const info = this.state;
    const { models } = this.props;

    const options = [];

    Object.keys(models).forEach(key => {
      options.push({ value: key, label: models[key].name + " " + models[key].cubicCapacity })
    });

    let img = law;
    if(info.model){
      img = (models[info.model.value].image.main);
    }


    return (
      <div className="bg-white p-5"
           style={{ minWidth: "300px", width: "90vw", maxWidth: "1500px", minHeight: "500px" }}>
        <form onSubmit={this.submit} className="row h-100 justify-content-center align-items-center">
          <div className="col-12 col-md-6">
            <div className="row h-100 justify-content-center align-items-center">
              <img width="90%" style={{ minWidth: "280px", maxWidth: "400px", opacity: 0.7 }} src={img} alt=""/>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="row px-5">
              <div className="col-12 col-xl-6">
                <div className="row mb-1">Modelo</div>
                <div className="row">
                  <Select
                    name="form-field-name"
                    value={info.model}
                    onChange={this.changeModel}
                    options={options}
                    className="rounded-0 w-100"
                  />
                </div>
              </div>
              <div className="col-12 col-xl-6">
                <MyInput title="Matricula" type="text" name="licensePlate" value={info.licensePlate}
                         onChange={this.changeInfo} captureErrors={this.captureErrors} notEmpty={true} maxChar={12}/>
              </div>
              <div className="col-12 offset-sm-6 col-sm-6 offset-md-0 col-md-12 offset-lg-6 col-lg-6 mt-4">
                <div className="row">
                  <MySubmit style={{height: "48px"}} className="bg-success" text="CREAR"/>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default ModalVespa;
